// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"ShippingAddress_messageBox__nNREr","bottomAction":"ShippingAddress_bottomAction__HIu_6"};